module.exports = __webpack_public_path__ + "img/moneySubscribe.ea0e0749.png";